import Cookies from 'js-cookie';
import CacheInstance from '../components/cache';
import SiteMessagesInstance from '../../../assets/js/components/site-messages'

const userLoggedIn = (options = {}) => {

  return new Promise((resolve, reject) => {

    let token = window.localStorage.getItem('token');

    if(!token) {
      token = Cookies.get('token');

      if(token) {
        token = decodeURIComponent(token);
      }

    }

    if(token) {

      window.apiRequest('post', '/authenticate').then(r => {

        if(r.type === 'success') {

          const data = r.data;

          Cookies.set('token', encodeURIComponent(data.token), { expires: 365 });

          window.localStorage.setItem('token', data.token);
          window.currentUser = data.user;

          // The account this session is looking at, persisted so the cache can be
          // namespaced by it before /authenticate has resolved on the next page
          // load — otherwise an offline read would look in the wrong namespace.
          window.localStorage.setItem(
            'account_id',
            String(data.user.account_id || data.user.id || '')
          );

          CacheInstance.save('authenticate', data);

          window.PubSub.publish('user_authenticated', data.user);
          resolve(data.token);

        } else {
          resolve(false);
        }

      });

    } else {
      resolve(false);
    }

  });

};

export default userLoggedIn;
